import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog', 'form', 'name', 'count', 'transfer', 'empty', 'crm', 'select', 'submit']

  open(event) {
    event?.preventDefault()

    const { user, name, url, count, crm } = event.params
    const hasActive = count > 0

    this.formTarget.action = url
    this.nameTarget.textContent = name
    this.countTarget.textContent = `${count} atendimento(s) ativo(s)`
    this.submitTarget.textContent = hasActive ? 'Desabilitar e transferir' : 'Desabilitar'

    this.transferTarget.hidden = !hasActive
    this.emptyTarget.hidden = hasActive
    this.crmTarget.hidden = !crm

    this.selectTarget.value = ''
    this.crmTarget.querySelector('input').checked = false
    // Ninguém pode herdar os próprios atendimentos: a lista é renderizada uma vez
    // com todo mundo, então quem está sendo desabilitado sai aqui.
    for (const option of this.selectTarget.options) {
      option.hidden = option.value === String(user)
      option.disabled = option.hidden
    }

    this.dialogTarget.showModal()
  }

  close(event) {
    event?.preventDefault()
    this.dialogTarget.close()
  }
}
